<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="9" lg="9">
            <v-card class="login" flat style="border-radius: 10px; padding: 0px;">
              <div style="margin: 5px; padding: 15px; text-align: center" v-if="carregamento == 'CARREGANDO'">
                <p>Carregando informações...</p>
                <v-progress-linear max-width="100px" indeterminate color="blue"></v-progress-linear>
              </div>

              <div style="margin: 0px; padding: 5px" v-if="carregamento == 'CARREGADO'">
                <v-card outlined>
                  <v-stepper v-model="stepper">
                    <v-stepper-header v-show="false">
                      <v-stepper-step :complete="stepper > 1" step="1" class="stepperHeader">Início</v-stepper-step>
                      <v-stepper-step :complete="stepper > 2" step="2" class="stepperHeader">Avaliação</v-stepper-step>
                      <v-stepper-step :step="quantidadeHeader" class="stepperHeader">Final</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                      <v-stepper-content step="1" style="padding: 0px;" class="stepperItems">
                        <v-card :img="require('../assets/bg1.png')" height="550px">
                          <v-row dense align="center" justify="center" style="position: relative; top: 50%; transform: translateY(-50%); text-align: center">
                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" align="center" justify="center" v-if="empresa.logoUrl">
                              <v-img :src="empresa.logoUrl" width="50%">
                                <template v-slot:placeholder>
                                  <v-row class="fill-height ma-0" align="center" justify="center">
                                    <v-progress-circular indeterminate color="white"></v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                              <br v-if="!this.$vuetify.breakpoint.lg">
                            </v-col>
                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" align="center" justify="center">
                              <h2 style="color: white; margin-bottom: 15px">Olá, {{ aula.aluno.nome.split(' ')[0] }}!</h2>
                              <v-img src="../assets/textscreen1.png" style="margin-bottom: 20px" width="80%"></v-img>
                              <v-btn dark @click="stepper++" outlined width="80%" rounded x-large v-if="aula.notaAula == 0"><b>Avaliar aula</b></v-btn>
                              <v-alert dark color="white" outlined dense style="margin: 0px 65px 0px 65px" v-else>Agradecemos por sua avaliação!</v-alert>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-stepper-content>

                      <v-stepper-content step="2" style="padding: 0px;" class="stepperItems">
                        <v-card :img="require('../assets/bg.png')" height="100%" class="pb-1">
                          <div style="text-align: center">
                            <br>
                            <v-img :src="empresa.logoUrl" width="150px" class="mx-auto"></v-img>
                            <h2 style="color: white; margin: 30px 10px 30px 10px" class="mx-auto">Dê uma nota para sua aula com {{ aula.professor.nome }}</h2>

                            <div>
                              <v-card outlined style="margin: 10px; border-radius: 50px" height="100%">
                                <div v-for="number in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="number" style="display: inline-block">
                                  <v-btn text class="d-flex flex-no-wrap justify-space-between" large height="80px" block @click="salvaResposta(number)">
                                    <img :src="require(`../assets/artboard${number}.png`)" alt="" width="50px">
                                  </v-btn>
                                </div>
                              </v-card>
                            </div>
                          </div>
                        </v-card>
                      </v-stepper-content>

                      <v-stepper-content step="3" style="padding: 0px" class="stepperItems">
                        <v-card :img="require('../assets/bgscreen3.png')" height="550px">
                          <br>
                          <v-img :src="empresa.logoUrl" width="150px" class="mx-auto"></v-img>
                          <v-row dense align="center" justify="center" style="position: relative; top: +35%; transform: translateY(-50%); text-align: center">  
                            <v-col cols="12" xs="12" sm="12" md="10" lg="10" align="center" justify="center">
                              <v-img src="../assets/textscreen3.png" style="margin-bottom: 20px" width="80%"></v-img>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                </v-card>
              </div>

              <div style="margin: 0px; padding: 5px; text-align: center" v-if="carregamento == 'ERRO'">
                <v-icon size="50">mdi-alert</v-icon>
                <p style="margin: 10px 0px 10px 0px">Problema ao carregar as informações</p>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <div class="login-title" style="margin-top: 10px">
          <p style="margin: 0px 0px 10px 0px; color: white; font-size: 12px" v-if="questionario.exibeTermoLgpd || empresa.bannerInicial">Ao usar nossa plataforma, você concorda com nossas <a target="_blank" style="color: white; text-decoration: underline" href="https://2eea8b7d-a702-46f5-8be7-466aa412f79b.usrfiles.com/ugd/2eea8b_6acd8479401b41da80bfe3bbf2a0d37d.pdf" @click.stop>políticas de privacidade e tratamento de dados pessoais</a>.</p>
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../assets/logo-branco-orizontal.png" width="140px">
          </a>
        </div>
      </v-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  /* import vueCard from 'vue-card-express'; */
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl, /* modelBoleto */ } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import { mapState } from 'vuex'
  import moment from 'moment'
  import axios from 'axios'
  export default {
    components: { Snackbar, Loading },
    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),
    data: function () {
      return {
        isLoading: false,
        fullPage: true,
        carregamento: '',
        textoFeedback: '',
        textoTelefone: '',
        codPesquisa: '',
        questionario: [],
        perguntas: [],
        empresa: [],
        stepper: 1,
        quantidadeHeader: 0,
        uniaoProfissionais: [],
        dictionary: {
          custom: {
            nomeCartao: {
              required: () => 'Informe o nome'
            },
            numCartao: {
              required: () => 'Informe o número do cartão de crédito',
            },
            cpftitular: {
              required: () => 'Informe o número do cartão de crédito',
            },
            codCartao: {
              required: () => 'Informe o código de segurança'
            },
            expiraCartaoMes: {
              required: () => 'Informe o mês de validade do cartão',
            },
            expiraCartaoAno: {
              required: () => 'Informe o ano de validade do cartão',
            },
            dateOfBirth: {
                required: () => 'Informe a Data de Nascimento' ,
                date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
            },
          }
        }
      }
    },
    
    mounted: function () {
      this.pegaParametrosUrl()
      setTimeout(() => {
        let number = document.getElementsByClassName('stepperHeader')
        this.quantidadeHeader = number.length
      }, 1500);
    },

    watch: {
      async stepper() {
        if (this.stepper == this.quantidadeHeader) {
          setTimeout(() => {
            this.stepper = 1
          }, 5000);
        }
      },
    },

    methods: {
      async pegaParametrosUrl() {
        this.carregamento = 'CARREGANDO'
        this.isLoading = true

        var params = window.location.search.substring(1).split('&');
        if (params[0] != '') {
          var paramArray = {};                        // Criar objeto que vai conter os parametros

          for (var i = 0; i < params.length; i++) {   // Passar por todos os parametros
            var param = params[i].split('=');         // Dividir os parametros chave e valor
            paramArray[param[0]] = param[1];          // Adicionar ao objeto criado antes
          }

          if (paramArray['sp']) {
            await this.carregaInformacoes(paramArray['sp'])
          }
        }
        this.isLoading = false
      },

      async carregaInformacoes(id) {
        await axios.get(baseApiUrl + 'ServicePaineis/' + id + '?filter={"include":["aluno","empresa","professor"]}')
        .then(response => {
          if (response.data) {
            if (response.data.aluno && response.data.empresa && response.data.professor) {
              this.aula = response.data
              this.empresa = response.data.empresa
              this.carregamento = 'CARREGADO'
            } else {
              this.carregamento = 'ERRO'
            }
          }
        })
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },

      async salvaResposta(nota) {
        await axios.patch(baseApiUrl + 'ServicePaineis/' + this.aula.id, {"notaAula": nota, "canal": "WEB"})
        .then(response => {
          if (response.data) {
            this.aula.notaAula = nota
            this.stepper++
          }
        })
      },
    }
  }
</script>

<style scoped>
  /* LOGIN */

  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #424f4e, #617574);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }

  a {
    text-decoration: none
  }
</style>
